const tableHead = [
    "创建时间",
    "序列号",
    "设备名称",
    "客户名称",
    "保养套餐",
    "代理商名称",
    "期望服务日期",
    "状态",
    "操作",
];

const tableBody = [
    {
        id: "t1",
        create_time: "2023-02-01",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "done",
    },
    {
        id: "t2",
        create_time: "2023-02-16",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "load",
    },
    {
        id: "t3",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "close",
    },
    {
        id: "t4",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "done",
    },
    {
        id: "t5",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "load",
    },
    {
        id: "t6",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "close",
    },
    {
        id: "t7",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "done",
    },
    {
        id: "t8",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "load",
    },
    {
        id: "t9",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "close",
    },
    {
        id: "t10",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "done",
    },
    {
        id: "t11",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "load",
    },
    {
        id: "t12",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "close",
    },
    {
        id: "t13",
        create_time: "2023-02-01 11:25:34",
        num: "BS700500115 BS70",
        equipment_name: "2BV5-500 2B",
        maintain_content: "大修-2BE1",
        agent_name: "上海重通设备机械有限公司",
        customer_name: "上海重通设备机械有限公司",
        service_time: "2023-02-01",
        status: "done",
    },
];

const priorityOptions = [
    { value: "1", label: "不紧急" },
    { value: "2", label: "紧急" },
    { value: "3", label: "非常紧急" },
];

const statusOptions = [
    { value: "1", label: "待处理" },
    { value: "2", label: "已处理" },
    { value: "3", label: "已关闭" },
];

const priorityColor = {
    1: "bg-success",
    2: "bg-warning",
    3: "bg-danger",
};

const statusColor = {
    1: "badge-soft-warning",
    2: "badge-soft-success",
    3: "badge-soft-dark",
};

const filterStatus = (type) => {
    let returnData;
    switch (type) {
        case 1:
        case "1":
            returnData = "待处理";
            break;
        case 2:
        case "2":
            returnData = "已处理";
            break;
        case 3:
        case "3":
            returnData = "已关闭";
            break;
    }
    return returnData;
}

const filterPriority = (type) => {
    let returnData;
    switch (type) {
        case 1:
        case "1":
            returnData = "不紧急";
            break;
        case 2:
        case "2":
            returnData = "紧急";
            break;
        case 3:
        case "3":
            returnData = "非常紧急";
            break;
    }
    return returnData;
}

const detailData = {
    describtion:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.",
    tableHead: [
        "设备类型",
        "设备名称",
        "机组序列号",
        "泵头序列号",
        "开机时间",
        "质保状态",
        "设备管理人",
        "联系电话",
    ],
    tableBody: [
        {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        }, {
            id: "t1",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "active",
            manager: "张磊",
            phone: "18567891234",
        },
        {
            id: "t2",
            equipment_type: "液环泵",
            equipment_name: "2BE12030BY3U02",
            equipment_num: "BS1700515001",
            equipment_head_num: "BS1700515001",
            open_time: "2018-03-05",
            status: "lazy",
            manager: "张磊",
            phone: "18567891234",
        },
    ],
    statusStyle: {
        active: {
            color: "badge-soft-success",
            text: "在保",
        },
        lazy: {
            color: "badge-soft-dark",
            text: "脱保",
        },
    },
    maintainHead: [
        "序号",
        "泵头序列号",
        "套餐名称",
        "套餐内容",
        "有效期止",
        "套餐状态",
    ],
    maintainBody: [
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
        {
            id: "m1",
            equipment_head_num: "BS1700515001",
            maintain_name: "大修-2BE1",
            maintain_content: "电机整体保养、涡轮保养、密封条更换",
            end_time: "2018-03-05",
            status: "active",
        },
    ]
};

const serviceInfo = [
    {
        label: "服务状态",
        value: "",
    },
    {
        label: "服务类型",
        value: "",
    },
    {
        label: "创建时间",
        value: "",
    },
    {
        label: "期望服务时间",
        value: "",
    },
    {
        label: "紧急程度",
        value: "",
    },
]
export {
    tableHead,
    tableBody,
    priorityOptions,
    statusOptions,
    priorityColor,
    statusColor,
    filterStatus,
    filterPriority,
    detailData,
    serviceInfo
};
